export default __webpack_public_path__ + "static/media/caitlin_tran.10234a98.jpeg";